import $ from 'jquery';

import React from 'react';
import ReactDOM, { render } from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCart from './Components/MiniCart';
import QuickSearch from './Components/QuickSearch';
import Navigation from './Components/Navigation';
import FacetedSearch from './Components/FacetedSearch';
import FacetedSearchTopBar from './Components/FacetedSearchTopBar';
import FilterPillsContainer from './Components/FilterPillsContainer';
import FacetedSearchCompactContainer from './Components/FacetedSearchCompactContainer';
import EventList from './Components/EventList';
import DynamicComponent from './Components/DynamicComponent';
import DownloadButton from './Components/DownloadButton';
import VimeoControls from './Components/VimeoControls';
import ImageGallery from './Components/ImageGallery';
import StickyFilter from './Components/StickyFilter';
import TableOfContents from './Components/TableOfContents';
import VimeoList from './Components/VimeoList';
import OpenLink from './Components/OpenLink';
import ProductCarousel from './Components/ProductCarousel';

import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { Foundation, OffCanvas } from 'foundation-sites';

Foundation.addToJquery($);
Foundation.plugin(Accordion, 'accordion');

document.addEventListener(
    'DOMContentLoaded',
    function () {
        $(document).foundation();
    },
    false,
);

VimeoControls.init();
VimeoList.init();
OpenLink.init();

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = (window.__litium.store =
    window.__litium.store ||
    (window.parent.__litium && window.parent.__litium.store) ||
    createStore(
        app,
        preloadState,
        composeWithDevTools(applyMiddleware(thunk, historyMiddleware)),
    ));

window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    registeredContainers.forEach(container => {
        ReactDOM.unmountComponentAtNode(container);
    });
};

const bootstrapComponents = () => {
    if (document.getElementById('image-gallery')) {
        var imageGalleryElement = document.getElementById('image-gallery');
        renderReact(
            <Provider store={store}>
                <ImageGallery
                    modalTitle={imageGalleryElement.getAttribute(
                        'data-modaltitle',
                    )}
                    images={JSON.parse(
                        imageGalleryElement.getAttribute('data-images'),
                    )}
                    title={imageGalleryElement.getAttribute('data-title')}
                    introduction={imageGalleryElement.getAttribute(
                        'data-introduction',
                    )}
                />
            </Provider>,
            document.getElementById('image-gallery'),
        );
    }
    if (document.getElementById('miniCart')) {
        renderReact(
            <Provider store={store}>
                <MiniCart />
            </Provider>,
            document.getElementById('miniCart'),
        );
    }
    if (document.getElementById('quickSearch')) {
        renderReact(
            <Provider store={store}>
                <QuickSearch />
            </Provider>,
            document.getElementById('quickSearch'),
        );
    }
    if (document.getElementById('navbar')) {
        var mobileNavbarElement = document.getElementById('navbar');
        renderReact(
            <Provider store={store}>
                <Navigation
                    display="mobile"
                    helpDeskUrl={mobileNavbarElement.getAttribute(
                        'data-helpdeskurl',
                    )}
                    addressInformation={mobileNavbarElement.getAttribute(
                        'data-addressinformation',
                    )}
                    channels={JSON.parse(
                        mobileNavbarElement.getAttribute('data-channels'),
                    )}
                    logo={mobileNavbarElement.getAttribute('data-logo')}
                />
            </Provider>,
            mobileNavbarElement,
        );
    }
    if (document.getElementById('navbar-desktop')) {
        var navbarElement = document.getElementById('navbar-desktop');
        renderReact(
            <Provider store={store}>
                <Navigation
                    display="desktop"
                    helpDeskUrl={navbarElement.getAttribute('data-helpdeskurl')}
                    addressInformation={navbarElement.getAttribute(
                        'data-addressinformation',
                    )}
                    channels={JSON.parse(
                        navbarElement.getAttribute('data-channels'),
                    )}
                    configuratorLink={JSON.parse(
                        navbarElement.getAttribute('data-configuratorLink')
                    )}
                    configuratorOpenMode={JSON.parse(
                        navbarElement.getAttribute('data-configuratorOpenMode')
                    )}
                    logo={navbarElement.getAttribute('data-logo')}
                    startpageurl={navbarElement.getAttribute(
                        'data-startpageurl',
                    )}
                />
            </Provider>,
            document.getElementById('header'),
        );

        let prevScrollPosition = window.pageYOffset;
        window.onscroll = () => {
            let currentScrollPosition = window.pageYOffset;
            if (prevScrollPosition > currentScrollPosition) {
                document.getElementById('header').classList.add('sticky');
            } else {
                document.getElementById('header').classList.remove('sticky');
            }
            prevScrollPosition = currentScrollPosition;
        };
    }
    if (document.querySelectorAll('#download-button').length > 0) {
        Array.from(document.querySelectorAll('#download-button')).forEach(
            button => {
                let articleNumberInput = button.getAttribute(
                    'data-information',
                );
                renderReact(
                    <Provider store={store}>
                        <DownloadButton articleNumber={articleNumberInput} />
                    </Provider>,
                    button,
                );
            },
        );
    }
    if (document.getElementById('facetedSearch')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearch showButton={false} />
            </Provider>,
            document.getElementById('facetedSearch'),
        );
    }

    if (document.getElementById('facetedSearchMobile')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearch showButton={true} />
            </Provider>,
            document.getElementById('facetedSearchMobile'),
        );
    }

    if (document.getElementById('facetedSearchTopBar')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchTopBar />
            </Provider>,
            document.getElementById('facetedSearchTopBar'),
        );
    }
    if (document.querySelectorAll('#filterPillsContainer').length > 0) {
        Array.from(document.querySelectorAll('#filterPillsContainer')).forEach(
            filterPills => {
                renderReact(
                    <Provider store={store}>
                        <FilterPillsContainer />
                    </Provider>,
                    filterPills,
                );
            },
        );
    }

    if (document.getElementById('stickyFilter')) {
        renderReact(
            <Provider store={store}>
                <StickyFilter />
            </Provider>,
            document.getElementById('stickyFilter'),
        );
    }

    if (document.getElementById('facetedSearchCompact')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact'),
        );
    }
    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Components/PersonListContainer'),
        });
        renderReact(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons'),
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Components/AddressListContainer'),
        });
        renderReact(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            document.getElementById('myPageAddresses'),
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Components/Checkout'),
        });
        renderReact(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout'),
        );
    }
    if (document.querySelectorAll('#lightBoxVideo').length > 0) {
        const LightboxVideo = DynamicComponent({
            loader: () => import('./Components/LightboxVideo'),
        });
        Array.from(document.querySelectorAll('#lightBoxVideo')).forEach(
            video => {
                let videoSrc = video.getAttribute('data-src');
                renderReact(
                    <Provider store={store}>
                        <LightboxVideo videoSrc={videoSrc} />
                    </Provider>,
                    video,
                );
            },
        );
    }
    if (document.getElementById('event-list-container')) {
        var eventListContainerElement = document.getElementById(
            'event-list-container',
        );
        renderReact(
            <Provider store={store}>
                <EventList
                    eventTags={JSON.parse(
                        eventListContainerElement.getAttribute(
                            'data-event-tags',
                        ),
                    )}
                    events={JSON.parse(
                        eventListContainerElement.getAttribute('data-events'),
                    )}
                    eventsToShow={JSON.parse(
                        eventListContainerElement.getAttribute(
                            'data-eventsToShow',
                        ),
                    )}
                    selectedTag={JSON.parse(
                        eventListContainerElement.getAttribute(
                            'data-selectedTag',
                        ),
                    )}
                />
            </Provider>,
            document.getElementById('event-list-container'),
        );
    }
    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Components/LightboxImages'),
        });
        const rootElement = document.getElementById('lightBoxImages');
        const images = Array.from(
            rootElement.querySelectorAll('a'),
        ).map(img => ({ src: img.dataset.src }));
        const thumbnails = Array.from(
            rootElement.querySelectorAll('a img'),
        ).map(img => ({ src: img.src }));
        renderReact(
            <Provider store={store}>
                <LightboxImages images={images} thumbnails={thumbnails} />
            </Provider>,
            document.getElementById('lightBoxImages'),
        );
    }

    if (document.getElementById('tableOfContents')) {
        const tableOfContents = document.getElementById('tableOfContents');
        const rawData = tableOfContents.getAttribute('data-tabs');
        const propsData = JSON.parse(rawData);
        const keys = [];

        for (const prop in propsData) {
            if (propsData[prop].length === 0) {
                continue;
            } else {
                keys.push(prop);
            }
        }

        renderReact(
            <Provider store={store}>
                <TableOfContents tabs={keys} isMobile={false} />
            </Provider>,
            tableOfContents,
        );
    }

    if (document.getElementById('tableOfContentsMobile')) {
        const tableOfContents = document.getElementById(
            'tableOfContentsMobile',
        );
        const rawData = tableOfContents.getAttribute('data-tabs');
        const propsData = JSON.parse(rawData);
        const keys = [];

        for (const prop in propsData) {
            if (propsData[prop].length === 0) {
                continue;
            } else {
                keys.push(prop);
            }
        }

        renderReact(
            <Provider store={store}>
                <TableOfContents tabs={keys} isMobile={true} />
            </Provider>,
            tableOfContents,
        );
    }

    document.addEventListener('tableOfContentsItemClick', event => {
        const tab = event.detail.tab;
        const isMobile = event.detail.mobile;
        const accordionHeader = document.getElementById('properties-accordion');

        if (!accordionHeader.classList.contains('active')) {
            accordionHeader.classList.add('active');
        }
        const tabHeader = document.querySelector(
            `.product-info-tab__header[data-key="${tab}"]`,
        );

        // Scrolls corresponding info tab to view
        if (tabHeader) {
            if (!tabHeader.classList.contains('active')) {
                tabHeader.classList.add('active');
                const productInfoKey = tabHeader.getAttribute('data-key');
                const infoRows = document.querySelectorAll(
                    '.product-info-tab__row[data-key="' + productInfoKey + '"]',
                );
                infoRows.forEach(row => row.classList.toggle('active'));
            }

            const navHeight = document.getElementById('header').offsetHeight;
            const topOfElement =
                document.querySelector(
                    `.product-info-tab__header[data-key="${tab}"]`,
                ).offsetTop - navHeight;

            tabHeader.scrollIntoView({
                behavior: 'smooth',
            });

            // Places tabHeader under sticky nav
            window.scroll({
                top: topOfElement,
                behavior: 'smooth',
            });

            // Close select drop down in mobile view
            if (isMobile) {
                document
                    .getElementById('custom_custom_range')
                    .classList.remove('is-open');
            }
        }
    });

    if (document.getElementById('productCarousel')) {
        const productCarousel = document.getElementById(
            'productCarousel',
        );
        const rawData = productCarousel.getAttribute('data-tabs');
        const propsData = JSON.parse(rawData);

        renderReact(
            <Provider store={store}>
                <ProductCarousel products={propsData} />
            </Provider>,
            productCarousel,
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider'),
        });
        Array.from(document.querySelectorAll('.slider')).forEach(
            (slider, index) => {
                const values = [
                    ...slider.querySelectorAll('.slider__block'),
                ].map(block => {
                    return {
                        image: block.dataset.image,
                        url: block.dataset.url,
                        text: block.dataset.text,
                        actionText: block.dataset.actionText,
                        backgroundColor: block.dataset.backgroundColor,
                    };
                });
                if (values.length > 0) {
                    renderReact(<Slider values={values} />, slider);
                }
            },
        );
    }
    if (document.querySelectorAll('.product-accordion__header').length > 0) {
        const productAccordions = document.querySelectorAll(
            '.product-accordion__header',
        );
        productAccordions.forEach(productAccordion => {
            productAccordion.addEventListener('click', () =>
                productAccordion.classList.toggle('active'),
            );
        });
    }
    if (document.querySelectorAll('.product-info-tab__header').length > 0) {
        const tabHeaders = document.querySelectorAll(
            '.product-info-tab__header',
        );
        tabHeaders.forEach(tabHeader => {
            tabHeader.addEventListener('click', () => {
                tabHeader.classList.toggle('active');
                const productInfoKey = tabHeader.getAttribute('data-key');
                const infoRows = document.querySelectorAll(
                    '.product-info-tab__row[data-key="' + productInfoKey + '"]',
                );
                infoRows.forEach(row => row.classList.toggle('active'));
            });
        });
    }
    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Components/BuyButton'),
        });
        Array.from(document.querySelectorAll('buy-button')).forEach(button => {
            const {
                articleNumber,
                quantityFieldId,
                href,
                cssClass,
                label,
            } = button.dataset;
            renderReact(
                <Provider store={store}>
                    <BuyButton
                        {...{
                            label,
                            articleNumber,
                            quantityFieldId,
                            href,
                            cssClass,
                        }}
                    />
                </Provider>,
                button,
            );
        });
    }
    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Components/ReorderButton'),
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach(
            button => {
                const { cssClass, orderId, title } = button.dataset;
                const label = button.innerText;
                renderReact(
                    <Provider store={store}>
                        <ReorderButton
                            {...{ label, title, cssClass, orderId }}
                        />
                    </Provider>,
                    button,
                );
            },
        );
    }
};

bootstrapComponents();
